import React from 'react';
import {
  Grid,
  Typography,
  CircularProgress,
  withStyles,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { withTranslation } from 'react-i18next';
import highchartsXrange from 'highcharts/modules/xrange';
import highchartsTimeline from 'highcharts/modules/timeline';
import Buttonbar from '../Navbar/Buttonbar';
import highchartsMore from 'highcharts/highcharts-more';
import CustomChartFooter from '../customChartFooter';

highchartsXrange(Highcharts);
highchartsTimeline(Highcharts);
highchartsMore(Highcharts);

class GarminWatchDetails extends React.PureComponent {
  getYXisData(dataSeries, isSecondaryYAxis = false) {
    const data = {
      title: {
        text: `${dataSeries.title}`,
        // align: "high",
        // offset: 0,
        // rotation: 0,
        // y: -20,
        style: {
          color: Highcharts.getOptions().colors[1],
        },
      },
      labels: {
        enabled: true,
        format: `{value} ${dataSeries.unit}`,
        style: {
          color: Highcharts.getOptions().colors[1],
        },
      },
      min: dataSeries.minValue,
      max: dataSeries.maxValue,
    };

    if (isSecondaryYAxis) {
      data['opposite'] = true;
    }

    return data;
  }

  getSeriesDataDaily(dataSeries, isSecondaryYAxis = false) {
    const data = {
      name: `${dataSeries.title}`,
      type: 'areaspline',
      data: dataSeries.data,
      color: dataSeries.color,
      fillColor: dataSeries.fillColor,
      tooltip: {
        pointFormat:
          `<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b>${dataSeries.unit}</span> ` +
          ' ',
      },
      marker: {
        symbol: 'circle',
      },
      visible: true,
    };

    if (isSecondaryYAxis) {
      data['yAxis'] = 1;
    }

    return data;
  }

  getSeriesDataPeriod(dataSeries, isSecondaryYAxis = false) {
    const data = [];
    const timestamp = new Date().getTime();
    const errorbar = {
      name: `${dataSeries.title}`,
      type: 'errorbar',
      data: dataSeries.minmax || [],
      tooltip: {
        pointFormat: `<span style="color:{point.color}">●</span> <span style="font-size: 12px;"> {series.name}: (min: {point.low}${dataSeries.unit}, max: {point.high}${dataSeries.unit})</span><br/>`,
      },
      yAxis: !isSecondaryYAxis ? 0 : 1,
      whiskerLength: 8,
      stemWidth: 2,
      color: '#E7E7E7',
      visible: this.props.isShowMinMax,
    };

    if (this.props.isShowMinMax) {
      errorbar.linkedTo = `${dataSeries.title}-${timestamp}`;
    }
    data.push(errorbar);

    const chart = {
      name: `${dataSeries.title}`,
      id: `${dataSeries.title}-${timestamp}`,
      type: 'spline',
      data: dataSeries.average,
      color: dataSeries.color,
      fillColor: dataSeries.fillColor,
      tooltip: {
        pointFormat:
          `<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> ${dataSeries.unit}</span> <br/>` +
          ' ',
      },
      yAxis: !isSecondaryYAxis ? 0 : 1,
      marker: {
        symbol: 'circle',
      },
    };
    data.push(chart);
    return data;
  }

  // getSeriesDataPeriod(dataSeries, isSecondaryYAxis = false) {
  //   const data = [
  //     {
  //       name: `${dataSeries.title}`,
  //       type: "errorbar",
  //       data: dataSeries.minmax || [],
  //       tooltip: {
  //         pointFormat: `<span style="color:{point.color}">●</span> <span style="font-size: 12px;"> {series.name}: (min: {point.low}${dataSeries.unit}, max: {point.high}${dataSeries.unit})</span><br/>`,
  //       },
  //       yAxis: !isSecondaryYAxis ? 0 : 1,
  //       whiskerLength: 8,
  //       stemWidth: 2,
  //       color: "#E7E7E7",
  //       visible: this.props.isShowMinMax,
  //     },
  //     {
  //       name: `${dataSeries.title}`,
  //       id: `${dataSeries.title}`,
  //       type: "spline",
  //       data: dataSeries.average,
  //       color: dataSeries.color,
  //       fillColor: dataSeries.fillColor,
  //       tooltip: {
  //         pointFormat:
  //           `<span style="color:{point.color}">●</span> <span style="font-size: 12px"> {series.name}: <b>{point.y}</b> ${dataSeries.unit}</span> <br/>` +
  //           " ",
  //       },
  //       yAxis: !isSecondaryYAxis ? 0 : 1,
  //       marker: {
  //         symbol: "circle",
  //       },
  //     },
  //   ];

  //   if (this.props.isShowMinMax) {
  //     data[0].linkedTo = `${dataSeries.title}`;
  //   }
  //   console.log('data: ', data[0])

  //   return data;
  // }

  getChartVitalSignsDaily(dataSeries1, dataSeries2) {
    const chart = {
      chart: {
        backgroundColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgb(230,244,243)'],
            [1, 'rgb(248,252,253, 0.1)'],
          ],
        },
        // zoomType: "x",
        // resetZoomButton: {
        //   theme: {
        //     display: "none",
        //   },
        // },
        // events: {
        //   selection: (event) => {
        //     if (event.originalEvent) {
        //       this.props.syncZoom(event, "bloodpressure");
        //     }
        //   },
        // },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemMarginTop: 10,
        itemMarginBottom: 5,
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          day: '%d/%m',
          year: '%y',
        },
        tickInterval: 2 * 60 * 60 * 1000,
      },
      yAxis: [],
      tooltip: {
        shared: true,
        headerFormat:
          '<span style="color:{point.color}"></span> <span style="font-size: 10px"> {point.x:%d/%m/%Y %H:%M:%S}</span><br/>',
      },
      plotOptions: {
        series: {
          lineWidth: 1,
        },
      },
      series: [],
    };

    if (dataSeries1 || dataSeries2) {
      const { classes } = this.props;

      if (dataSeries1) {
        const yAxis = this.getYXisData(dataSeries1);
        const dataSeries = this.getSeriesDataDaily(dataSeries1);

        chart.yAxis.push(yAxis);
        chart.series.push(dataSeries);
      }

      if (dataSeries2) {
        const yAxis = this.getYXisData(dataSeries2, true);
        const dataSeries = this.getSeriesDataDaily(dataSeries2, true);

        chart.yAxis.push(yAxis);
        chart.series.push(dataSeries);
      }

      return (
        <Typography component='div' className={classes.vitalSignsChart}>
          <HighchartsReact
            highcharts={Highcharts}
            options={chart}
            // callback={this.props.dataChartHRVsTemp}
          />
        </Typography>
      );
    }
  }

  getChartVitalSignsPeriod(dataSeries1, dataSeries2, viewType) {
    let tickInterval = 0;
    if (viewType === 'weekly') {
      tickInterval = 1;
    } else if (viewType === 'monthly') {
      tickInterval = 2;
    }
    const chart = {
      chart: {
        backgroundColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, 'rgb(230,244,243)'],
            [1, 'rgb(248,252,253, 0.1)'],
          ],
        },
        // zoomType: "x",
        // resetZoomButton: {
        //   theme: {
        //     display: "none",
        //   },
        // },
        // events: {
        //   selection: (event) => {
        //     if (event.originalEvent) {
        //       this.props.syncZoom(event, "spo2");
        //     }
        //   },
        // },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemMarginTop: 10,
        itemMarginBottom: 5,
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          day: '%d/%m',
          month: '%m/%y',
          year: '%m/%y',
        },
        tickInterval: 85400 * 1000 * tickInterval,
      },
      yAxis: [],
      tooltip: {
        shared: true,
        headerFormat:
          '<span style="color:{point.color}"></span> <span style="font-size: 10px"> {point.x:%d/%m/%Y}</span><br/>',
      },
      plotOptions: {
        series: {
          lineWidth: 2,
          // showInLegend: false,
        },
      },
      series: [],
    };

    if (dataSeries1 || dataSeries2) {
      const { classes } = this.props;

      if (dataSeries1) {
        const yAxis = this.getYXisData(dataSeries1);
        const dataSeries = this.getSeriesDataPeriod(dataSeries1);

        chart.yAxis.push(yAxis);
        dataSeries.forEach((data) => {
          chart.series.push(data);
        });
        // chart.series.push(...dataSeries);
      }

      if (dataSeries2) {
        const yAxis = this.getYXisData(dataSeries2, true);
        const dataSeries = this.getSeriesDataPeriod(dataSeries2, true);

        chart.yAxis.push(yAxis);
        dataSeries.forEach((data) => {
          chart.series.push(data);
        });
        // chart.series.push(...dataSeries);
      }

      return (
        <Typography component='div' className={classes.vitalSignsChart}>
          <HighchartsReact
            highcharts={Highcharts}
            options={chart}
            // callback={this.props.dataChartSpo2}
          />
        </Typography>
      );
    }
  }

  getHeartrateDataSeries(data, average, resting, minmax) {
    const { t } = this.props;
    return {
      title: `${t('heart_rate')}`,
      unit: 'bpm',
      minValue: 0,
      maxValue: 160,
      color: '#EB5861',
      fillColor: {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [
          [0, 'rgba(235,88,97,0.9)'],
          [1, 'rgba(244,244,244,0.2)'],
        ],
      },
      data: data,
      average: average,
      resting: resting,
      minmax: minmax,
    };
  }

  getSpo2DataSeries(data, average, minmax) {
    const { t } = this.props;
    return {
      title: `${t('spo2')}`,
      unit: '%',
      minValue: 0,
      maxValue: 120,
      color: '#009D9A',
      fillColor: {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [
          [0, 'rgba(0,157,154,0.8)'],
          [1, 'rgba(244,244,244,0.2)'],
        ],
      },
      data: data,
      average: average,
      minmax: minmax,
    };
  }

  getRespirationDataSeries(data, average, minmax) {
    const { t } = this.props;
    return {
      title: `${t('respiratory_rate')}`,
      unit: 'bpm',
      minValue: 0,
      maxValue: 30,
      color: '#FEB84F',
      fillColor: {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [
          [0, 'rgba(254, 184, 79,0.8)'],
          [1, 'rgba(244,244,244,0.2)'],
        ],
      },
      data: data,
      average: average,
      minmax: minmax,
    };
  }

  render() {
    const { classes, t } = this.props;
    const {
      summaryHeartrate,
      summarySpo2,
      summaryRespiration,
      dailyHeartrateData,
      dailySpo2Data,
      dailyRespirationData,
      loading,
    } = this.props.smartwatchsummary.toJS();

    const chartSeries = [];
    if (this.props.vitalsigns.includes('heartrate')) {
      const series =
        this.props.viewType === 'daily'
          ? this.getHeartrateDataSeries(dailyHeartrateData, null, null, null)
          : this.getHeartrateDataSeries(
              null,
              summaryHeartrate.average,
              summaryHeartrate.resting,
              summaryHeartrate.minmax,
            );
      chartSeries.push(series);
    }
    if (this.props.vitalsigns.includes('spo2')) {
      const series =
        this.props.viewType === 'daily'
          ? this.getSpo2DataSeries(dailySpo2Data, null, null)
          : this.getSpo2DataSeries(null, summarySpo2.average, summarySpo2.minmax);
      chartSeries.push(series);
    }
    if (this.props.vitalsigns.includes('respiration')) {
      const series =
        this.props.viewType === 'daily'
          ? this.getRespirationDataSeries(dailyRespirationData, null, null)
          : this.getRespirationDataSeries(null, summaryRespiration.average, summaryRespiration.minmax);
      chartSeries.push(series);
    }

    return (
      <div className='flex-wrap flex-auto w-screen bg-gradient-to-b from-primary-gradient to-transparent'>
        <div className='flex-wrap w-full pt-3 mx-auto px-19 md:flex lg:h-85vh xl:h-0'>
          {this.props.zoom && (
            <div className='flex-wrap w-full pt-1 mx-auto pb-7 md:flex h-25 space-5'>
              <div className='relative items-end justify-end flex-grow text-right'>
                <button
                  className='bottom-0 right-0 h-10 px-5 text-sm font-bold text-gray-600 border border-gray-300 rounded-lg bg-button-download '
                  onClick={this.props.resetZoom}
                >
                  {t('reset_zoom')}
                </button>
              </div>
            </div>
          )}
          {!loading ? (
            dailyHeartrateData.length > 2 || dailySpo2Data.length > 0 || dailyRespirationData.length > 0 ? (
              <div className='relative flex-col flex-wrap w-full min-h-full pb-5 bg-white rounded shadow-lg md:box-content '>
                <div className='block col-span-12 px-1 pt-4 lg:flex md:flex xl:flex'>
                  <Buttonbar
                    onChangePeriod={this.props.onChangePeriod}
                    viewType={this.props.viewType}
                    isDisplayDaily={true}
                    t={t}
                  />
                </div>
                <div className='flex flex-wrap col-span-12 px-10 pt-2 mt-1'>
                  <div className='flex xl:w-2/3 '>
                    <div className='flex items-center mr-3 text-secondary'>{t('select_up_to_2_items')}</div>
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            defaultChecked={this.props.heartrate}
                            value='heartrate'
                            onChange={this.props.handleChangeVitalsign('heartrate')}
                            disabled={this.props.vitalsigns.length === 2 && !this.props.heartrate}
                          />
                        }
                        label={t('heart_rate')}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            defaultChecked={this.props.spo2}
                            value='spo2'
                            onChange={this.props.handleChangeVitalsign('spo2')}
                            disabled={this.props.vitalsigns.length === 2 && !this.props.spo2}
                          />
                        }
                        label={t('spo2')}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            defaultChecked={this.props.respiration}
                            value='respiration'
                            onChange={this.props.handleChangeVitalsign('respiration')}
                            disabled={this.props.vitalsigns.length === 2 && !this.props.respiration}
                          />
                        }
                        label={t('respiratory_rate')}
                      />
                    </FormGroup>
                  </div>
                  <div className='flex xl:justify-end xl:w-1/3'>
                    {this.props.viewType !== 'daily' && (
                      <FormControlLabel
                        className='mr-1'
                        control={
                          <Checkbox
                            checked={this.props.isShowMinMax}
                            onChange={this.props.handleChange}
                            style={{
                              color: '#B9D0CE',
                            }}
                          />
                        }
                        label={t('show_min_max')}
                      />
                    )}
                  </div>
                </div>
                <div className='px-8 pb-5 h-96'>
                  {this.props.viewType === 'daily' ? (
                    <div className='p-2'>
                      {this.props.vitalsigns.length === 0 ? (
                        <div className={classes.card}>
                          <Typography>{t('please_select_vitalsign')}</Typography>
                        </div>
                      ) : (
                        <div>
                          {this.props.vitalsigns.length > 0 && chartSeries && chartSeries.length > 0 ? (
                            chartSeries.length === 1 ? (
                              this.getChartVitalSignsDaily(chartSeries[0], null)
                            ) : (
                              this.getChartVitalSignsDaily(chartSeries[0], chartSeries[1])
                            )
                          ) : (
                            <div className={classes.card}>
                              <Typography>{t('no_data')}</Typography>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className='p-2'>
                      {this.props.vitalsigns.length === 0 ? (
                        <div className={classes.card}>
                          <Typography>{t('please_select_vitalsign')}</Typography>
                        </div>
                      ) : (
                        <div>
                          {chartSeries && chartSeries.length > 0 ? (
                            chartSeries.length === 1 ? (
                              this.getChartVitalSignsPeriod(chartSeries[0], null, this.props.viewType)
                            ) : (
                              this.getChartVitalSignsPeriod(chartSeries[0], chartSeries[1], this.props.viewType)
                            )
                          ) : (
                            <div className={classes.card}>
                              <Typography>{t('no_data')}</Typography>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className='mb-2'>
                  <CustomChartFooter
                    endDate={this.props.endDate}
                    startDate={this.props.startDate}
                    viewType={this.props.viewType}
                    handleBackButtonClick={this.props.handleBackButtonClick}
                    handleNextButtonClick={this.props.handleNextButtonClick}
                  />
                </div>
              </div>
            ) : (
              <div className='w-full max-h-screen bg-white rounded md:box-content'>
                <Grid container>
                  <Typography component='div' className={classes.noDataBox}>
                    {' '}
                    {t('no_data')}
                  </Typography>
                </Grid>
              </div>
            )
          ) : (
            <div className='flex justify-center w-full text-center'>
              <div className='flex mt-4'>
                <CircularProgress size={26} />
                <div className='px-5 pt-0.5  text-base text-gray-600'>{t('loading')}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  card: {
    // width: "100%",
    justifyContent: 'center',
    textAlign: 'center',
    margin: '10px auto',
    padding: '20px 50px',
    backgroundColor: '#F6F8F9',
  },
  vitalSignsChart: {
    width: '100%',
    // paddingTop: "10px",
  },
  alignRight: {
    display: 'flex',
    justifyContent: 'right',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'left',
      marginTop: 10,
    },
  },
  noDataBox: {
    padding: 8 * 3,
    fontSize: 16,
    fontFamily: 'kanit',
    fontWeight: 600,
    color: theme.palette.text.header,
  },
});

export const page = inject('smartwatchsummary')(observer(GarminWatchDetails));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
